<div class="ss-toast" *ngIf="toastMessage" [class.ss-toast-error]="toastType === 'error'">{{ toastMessage }}</div>

<div class="user-page">
  <div class="page-header-row">
    <h1 class="ss-page-title">Users</h1>
    <button class="ss-btn ss-btn-primary" data-bs-toggle="modal" data-bs-target="#staticBackdrop">
      Add User
    </button>
  </div>

  <div class="ss-filter-bar">
    <input class="ss-input" style="max-width:260px" type="text" placeholder="Search by name or email…"
      [(ngModel)]="userSearchTerm" (ngModelChange)="onSearchChange()" />
  </div>

  <!-- Loading -->
  <div class="ss-loading" *ngIf="loading">
    <div class="ss-spinner"></div> Loading…
  </div>

  <!-- Table -->
  <div class="user-table-wrap" *ngIf="users && users.length && !loading">
    <table class="ss-table">
      <thead>
        <tr>
          <th>Name</th>
          <th>Email</th>
          <th>Role</th>
          <th>IP</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let user of paginatedUsers"
            [class.deactivated-row]="!user.isActive"
            [class.current-row]="user.userName === currentUsername">
          <td>{{ user.name }} <small *ngIf="user.userName === currentUsername" style="color:var(--color-text-muted)">(you)</small></td>
          <td>{{ user.email }}</td>
          <td>
            <span class="role-label"
              [ngClass]="{'role-admin': user.role === 'Admin', 'role-store-admin': user.role === 'StoreAdmin'}">
              {{ user.role }}
            </span>
          </td>
          <td style="color:var(--color-text-muted)">{{ user.ipAddress || '—' }}</td>
          <td>
            <div class="row-actions">
              <ng-container *ngIf="user.isActive; else deactivatedActions">
                <button class="ss-btn ss-btn-secondary ss-btn-sm" (click)="openEditUser(user)">Edit</button>
                <button class="ss-btn ss-btn-secondary ss-btn-sm" (click)="openResetPassword(user)">Reset PW</button>
                <button class="ss-btn ss-btn-danger ss-btn-sm" *ngIf="user.userName !== currentUsername" (click)="deactivateUser(user)">Deactivate</button>
              </ng-container>
              <ng-template #deactivatedActions>
                <span class="deactivated-badge">Deactivated</span>
                <button class="ss-btn ss-btn-success ss-btn-sm reactivate-btn" (click)="reactivateUser(user)">Reactivate</button>
              </ng-template>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="ss-empty" *ngIf="users && users.length === 0 && !loading">No users found.</div>

  <!-- Pagination -->
  <div class="pagination-bar" *ngIf="filteredUsers().length > pageSize && !loading">
    <button class="ss-btn ss-btn-secondary ss-btn-sm" (click)="previousPage()" [disabled]="pageNumber === 1">Previous</button>
    <button *ngFor="let page of visiblePages()" class="ss-btn ss-btn-secondary ss-btn-sm"
      [style.background]="page === pageNumber ? 'var(--color-accent)' : ''"
      [style.color]="page === pageNumber ? 'white' : ''"
      (click)="goToPage(page)">{{ page }}</button>
    <button class="ss-btn ss-btn-secondary ss-btn-sm" (click)="nextPage()" [disabled]="pageNumber >= totalPages()">Next</button>
  </div>
</div>

<!-- Add User Modal -->
<div class="modal fade" id="staticBackdrop" (shown.bs.modal)="resetAddUserForm(addUserForm)"
  data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Add User</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" (click)="onModalClose()"></button>
      </div>
      <form #addUserForm="ngForm">
        <div class="modal-body">
          <div class="form-group">
            <label class="form-label">Name</label>
            <input type="text" class="form-control" name="addName" [(ngModel)]="name" placeholder="John Doe" [disabled]="disabled" />
          </div>
          <div class="form-group">
            <label class="form-label">Email</label>
            <input type="email" class="form-control" name="addEmail" [(ngModel)]="email" placeholder="name@example.com"
              required pattern="^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$" #addEmailCtrl="ngModel" [disabled]="disabled" />
            <div class="text-danger" *ngIf="addFormSubmitted && addEmailCtrl.invalid">
              <small *ngIf="addEmailCtrl.errors?.['required']">Email is required</small>
              <small *ngIf="addEmailCtrl.errors?.['pattern']">Enter a valid email</small>
            </div>
          </div>
          <div class="form-group">
            <label class="form-label">IP Address</label>
            <input type="text" class="form-control" name="addIpAddress" [(ngModel)]="ipAddress" [disabled]="disabled" />
          </div>
          <div class="form-group">
            <label class="form-label">Role</label>
            <select class="form-select" name="addRole" [(ngModel)]="selectedRole" [disabled]="disabled">
              <option value="" disabled selected>Select role</option>
              <option value="StoreAdmin">Store Admin</option>
              <option value="StoreUser">Store User</option>
            </select>
          </div>

          <!-- Credential display after creation -->
          <div *ngIf="username" class="credentials-box">
            <div class="cred-label">Token</div>
            <div class="cred-row"><input [value]="token" readonly /></div>
            <div style="display:flex;gap:8px;margin-bottom:8px">
              <input [value]="username" readonly style="flex:1;padding:6px 10px;border:1px solid var(--color-border);border-radius:4px;font-size:12px;font-family:monospace" />
              <input [value]="password" readonly style="flex:1;padding:6px 10px;border:1px solid var(--color-border);border-radius:4px;font-size:12px;font-family:monospace" />
            </div>
            <button class="ss-btn ss-btn-secondary ss-btn-sm" (click)="copyToken()">Copy All</button>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="ss-btn ss-btn-secondary" data-bs-dismiss="modal" (click)="onModalClose()">Close</button>
          <button type="button" class="ss-btn ss-btn-primary" (click)="onAddUser(addUserForm)" [disabled]="disabled">Add User</button>
        </div>
      </form>
    </div>
  </div>
</div>

<!-- Edit User Modal -->
<div class="modal fade" id="editUserModal" tabindex="-1">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Edit User</h5>
        <button class="btn-close" data-bs-dismiss="modal"></button>
      </div>
      <form #editForm="ngForm">
        <div class="modal-body">
          <div class="form-group">
            <label class="form-label">Username</label>
            <input type="text" class="form-control" [value]="editUser.userName" readonly />
          </div>
          <div class="form-group">
            <label class="form-label">Full Name</label>
            <input type="text" class="form-control" name="name" [(ngModel)]="editUser.name" required />
          </div>
          <div class="form-group">
            <label class="form-label">Email</label>
            <input type="text" class="form-control" name="email" [(ngModel)]="editUser.email"
              required pattern="^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$" #emailCtrl="ngModel" />
            <div class="text-danger" *ngIf="emailCtrl.invalid && emailCtrl.touched">
              <small *ngIf="emailCtrl.errors?.['required']">Email is required</small>
              <small *ngIf="emailCtrl.errors?.['pattern']">Enter a valid email</small>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button class="ss-btn ss-btn-secondary" data-bs-dismiss="modal">Cancel</button>
          <button class="ss-btn ss-btn-primary" (click)="updateUser()" [disabled]="editForm.invalid">Update</button>
        </div>
      </form>
    </div>
  </div>
</div>

<!-- Reset Password Modal -->
<div class="modal fade" id="resetPasswordModal" tabindex="-1">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Reset Password</h5>
        <button class="btn-close" data-bs-dismiss="modal"></button>
      </div>
      <div class="modal-body">
        <div class="form-group">
          <label class="form-label">New Password</label>
          <div style="display:flex;gap:8px">
            <input [type]="showPassword ? 'text' : 'password'" class="form-control" [(ngModel)]="newPassword" placeholder="Enter new password" />
            <button type="button" class="ss-btn ss-btn-secondary" (click)="togglePassword()">
              {{ showPassword ? 'Hide' : 'Show' }}
            </button>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button class="ss-btn ss-btn-secondary" data-bs-dismiss="modal">Cancel</button>
        <button class="ss-btn ss-btn-primary" (click)="confirmResetPassword()">Reset</button>
      </div>
    </div>
  </div>
</div>
